// for fetching the current week number
export function getWeekNumber(nxtwk, date = new Date()) {
    const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = tempDate.getUTCDay() || 7;

    tempDate.setUTCDate(tempDate.getUTCDate() + 4 - day);

    const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((tempDate - yearStart) / 86400000) + 1) / 7);
    // const weekNo = 23

    return weekNo + nxtwk;
}
export const tableWeekColumns = [
    {
        "label": "Week_N+0",
        "DisplayLabel": `Wk ${getWeekNumber(0)}`,
        "visibility": true,
        "DisplayOrder": 1,
        "sortable": false
    },
    {
        "label": "Week_N+1",
        "DisplayLabel": `Wk ${getWeekNumber(1)}`,
        "visibility": true,
        "DisplayOrder": 2,
        "sortable": false
    },
    {
        "label": "Week_N+2",
        "DisplayLabel": `Wk ${getWeekNumber(2)}`,
        "visibility": true,
        "DisplayOrder": 3,
        "sortable": false
    },
    {
        "label": "Week_N+3",
        "DisplayLabel": `Wk ${getWeekNumber(3)}`,
        "visibility": true,
        "DisplayOrder": 4,
        "sortable": false
    },
    {
        "label": "Week_N+4",
        "DisplayLabel": `Wk ${getWeekNumber(4)}`,
        "visibility": true,
        "DisplayOrder": 5,
        "sortable": false
    }
];
export const parameterTableColumns = [
    'Parameters', 
    `Wk ${getWeekNumber(0)}`, 
    `Wk ${getWeekNumber(1)}`, 
    `Wk ${getWeekNumber(2)}`, 
    `Wk ${getWeekNumber(3)}`, 
    `Wk ${getWeekNumber(4)}`
]
export const initialGraph = [
    {
        name: `Wk ${getWeekNumber(0)}`,
        week: getWeekNumber(0),
        planProduction: 0,
        predictedProduction: 0
    },
    {
        name: `Wk ${getWeekNumber(1)}`,
        week: getWeekNumber(1),
        planProduction: 0,
        predictedProduction: 0
    },
    {
        name: `Wk ${getWeekNumber(2)}`,
        week: getWeekNumber(2),
        planProduction: 0,
        predictedProduction: 0
    },
    {
        name: `Wk ${getWeekNumber(3)}`,
        week: getWeekNumber(3),
        planProduction: 0,
        predictedProduction: 0
    },
    {
        name: `Wk ${getWeekNumber(4)}`,
        week: getWeekNumber(4),
        planProduction: 0,
        predictedProduction: 0
    }
];